module.exports = __webpack_public_path__ + "img/VetsGo-Login-Tablet.227a58cb.svg";